export const HEARTBEAT_DE = {
  heartbeat: 'Agent',
  heartbeatDescription: 'Geplante Aufgaben überwachen und verwalten',
  createMonitor: 'Monitor erstellen',
  editMonitor: 'Monitor bearbeiten',
  deleteMonitor: 'Monitor löschen',
  monitorName: 'Name',
  monitorDescription: 'Beschreibung',
  taskType: 'Aufgabentyp',
  taskQuery: 'Aufgabenabfrage',
  taskQueryPlainLanguageHint:
    'E-Mails werden standardmäßig auf Deutsch und verständlich für nicht-technische Leser formuliert (klare Zusammenfassung, Auswirkung und nächste Schritte).',
  modelSelectPlaceholder: 'Modell auswählen',
  modelLoading: 'Verfügbare Modelle werden geladen...',
  modelLoadFailed:
    'Modellliste nicht verfügbar. Speichern ist deaktiviert, bis Modelle geladen sind.',
  modelFallbackHint:
    'Keine auswählbaren Modelle gefunden. Speichern ist deaktiviert, bis ein Modell verfügbar ist.',
  heartbeatWebSearchEnabled: 'Websuche aktivieren',
  webSearchEnabledHint: 'Wenn deaktiviert, läuft Agent ohne Web-Grounding.',
  schedulePreset: 'Zeitplan-Vorlage',
  presetDaily: 'Täglich',
  presetWeekly: 'Wöchentlich',
  presetMonthly: 'Monatlich',
  dayOfMonth: 'Tag des Monats',
  dayOfMonthHint: 'Läuft an diesem Tag jedes Monats (1–28).',
  weeklyDay: 'Wochentag',
  weekdayMon: 'Montag',
  weekdayTue: 'Dienstag',
  weekdayWed: 'Mittwoch',
  weekdayThu: 'Donnerstag',
  weekdayFri: 'Freitag',
  weekdaySat: 'Samstag',
  weekdaySun: 'Sonntag',
  scheduleType: 'Zeitplantyp',
  timeOfDay: 'Tageszeit',
  timezone: 'Zeitzone',
  outputChannel: 'Versandkanal',
  outputTargetEmail: 'Versand-E-Mail',
  outputTargetEmailHint: 'Agent-Ergebnisse werden an Ihre Account-E-Mail gesendet.',
  outputTargetEmailUnavailable:
    'Keine Account-E-Mail gefunden. Hinterlegen Sie eine Account-E-Mail, um speichern zu können.',
  outputTargetEmailInvalid: 'Bitte eine gültige E-Mail-Adresse eingeben.',
  enabled: 'Aktiviert',
  paused: 'Pausiert',
  active: 'Aktiv',
  currentlyExecuting: 'Wird gerade ausgeführt',
  lastExecution: 'Letzte Ausführung',
  nextScheduled: 'Nächste geplante Ausführung',
  nextRunNow: 'Nächste Ausführung jetzt',
  nextRunInMinutes: 'Nächste Ausführung in {count} Min.',
  nextRunInHours: 'Nächste Ausführung in {count} Stunde(n)',
  nextRunInDays: 'Nächste Ausführung in {count} Tag(en)',
  executeNow: 'Jetzt ausführen',
  pauseMonitor: 'Pausieren',
  resumeMonitor: 'Fortsetzen',
  noMonitors: 'Noch keine Agenten',
  noMonitorsDescription: 'Erstellen Sie einen Agenten, um geplante Aufgaben zu verfolgen',
  searchMonitors: 'Agenten durchsuchen...',
  noMonitorsFound: 'Keine Agenten gefunden',
  clearSearch: 'Suche löschen',
  confirmDeleteMessage:
    'Sind Sie sicher, dass Sie diesen Monitor löschen möchten? Diese Aktion kann nicht rückgängig gemacht werden.',
  monitorCreated: 'Monitor erfolgreich erstellt',
  monitorUpdated: 'Monitor erfolgreich aktualisiert',
  monitorDeleted: 'Monitor erfolgreich gelöscht',
  monitorPaused: 'Monitor pausiert',
  monitorResumed: 'Monitor fortgesetzt',
  executionTriggered: 'Ausführung ausgelöst',
  monitorCreateFailed: 'Monitor konnte nicht erstellt werden',
  monitorUpdateFailed: 'Monitor konnte nicht aktualisiert werden',
  monitorDeleteFailed: 'Monitor konnte nicht gelöscht werden',
  monitorPauseFailed: 'Monitor konnte nicht pausiert werden',
  monitorResumeFailed: 'Monitor konnte nicht fortgesetzt werden',
  executionTriggerFailed: 'Ausführung konnte nicht ausgelöst werden',
  executionAlreadyRunning: 'Für diesen Monitor läuft bereits eine Ausführung.',
  monitorRateLimitReached: 'Rate-Limit erreicht. Bitte versuchen Sie es später erneut.',
  research: 'Recherche',
  geo: 'Geo',
  generation: 'Generierung',
  cron: 'Cron',
  dailyAt: 'Täglich um',
  everyNMinutes: 'Alle {count} Min.',
  create: 'Erstellen',
  executionHistory: 'Ausführungsverlauf',
  executionResult: 'Ausführungsergebnis',
  noExecutions: 'Noch keine Ausführungen',
  noExecutionsDescription: 'Dieser Monitor wurde noch nicht ausgeführt',
  executionRun: 'Lauf {count}',
  resultPreviewUnavailable:
    'Keine Ergebnisvorschau verfügbar. Öffnen Sie den Lauf für die volle Ausgabe.',
  viewFullResult: 'Vollständiges Ergebnis anzeigen',
  executionDetails: 'Ausführungsdetails',
  executionStatus: 'Status',
  statusStart: 'Gestartet',
  statusSent: 'Gesendet',
  statusStep: 'Schritt',
  statusRunning: 'Laufend',
  statusInProgress: 'In Bearbeitung',
  statusPending: 'Ausstehend',
  statusFinished: 'Abgeschlossen',
  statusDone: 'Erledigt',
  statusCompleted: 'Abgeschlossen',
  statusSuccess: 'Erfolgreich',
  statusSucceeded: 'Erfolgreich',
  statusError: 'Fehler',
  statusFailed: 'Fehlgeschlagen',
  statusFailure: 'Fehler',
  statusNeverRun: 'Nie ausgeführt',
  statusQueued: 'In Warteschlange',
  statusCancelled: 'Abgebrochen',
  statusTimeout: 'Zeitüberschreitung',
  statusSkipped: 'Übersprungen',
  statusDelivered: 'Zugestellt',
  executionTrigger: 'Auslöser',
  executionStart: 'Gestartet',
  executionEnd: 'Beendet',
  resultTab: 'Ergebnis',
  addResultToEditor: 'Zum Editor hinzufügen',
  sourcesTab: 'Quellen',
  statsTab: 'Statistik',
  resultUnavailable: 'Für diese Ausführung liegt kein Ergebnis vor.',
  sourcesUnavailable: 'Für diese Ausführung sind keine Quellen verfügbar.',
  resultTruncated: '[Ergebnis zur besseren Lesbarkeit gekürzt]',
  citationCount: 'Quellenanzahl',
  deliveryStatus: 'Zustellstatus',
  deliveryTime: 'Zustellzeit',
  deliveryError: 'Zustellfehler',
  notAvailable: 'Nicht verfügbar',
  changeSummary: 'Änderungszusammenfassung',
  citations: 'Quellenangaben',
  errorMessage: 'Fehler',
  scheduled: 'Geplant',
  manual: 'Manuell',
  backToMonitors: 'Zurück zu Monitoren',
  viewExecutions: 'Ausführungen anzeigen',
  totalCost: 'Gesamtkosten'
}
